import React, { useEffect } from 'react'

import PageLayout from 'components/layouts/PageLayout'
import SectionLayout from 'components/layouts/SectionLayout'
import SmallBanner from 'components/SmallBanner'
import { onlineQuotesContent } from './content/onlineQuotesContent'

function OnlineQuotes() {

  useEffect(() => {
    // Change Tab Title
    document.title = "Online Quotes - Insurance Enterprise"
  }, [])

  const onlineQuotesBannerContent = (
    <div className='text-2xl'>
      Online Quotes Form
    </div>
  )

  //* WHOLE ONLINE QUOTE FORM, NOT SEGMENTED
  // const onlineQoutesFormLayout = (
  //   <div className='shadow-xl border border-slate-300 p-12 max-w-4xl mx-auto'>
  //     <div className='text-center font-bold text-3xl'>Online Quote Form</div>
  //     <OnlineQouteForm />
  //   </div>
  // )

  return (
    <>

      <SmallBanner content={onlineQuotesBannerContent} />
      <PageLayout
        content={
          <SectionLayout content={onlineQuotesContent} />
        }
      />

    </>
  )
}

export default OnlineQuotes